class ExpressionParser {
  static getNestedValue = (obj, path) => {
    return path.split(".").reduce((current, key) => {
      return current && current[key] !== undefined ? current[key] : undefined
    }, obj)
  }

  static evaluateExpression = (expression) => {
    const sanitized = expression.replace(/\s+/g, "")

    if (!/^[\d./+\-*()]+$/.test(sanitized)) return expression

    try {
      return new Function(`return ${sanitized}`)()
    } catch (e) {
      return expression
    }
  }

  static evaluate = (expression, data) => {
    if (!expression || !data) return expression

    if (typeof expression === "string") {
      // First pass: Replace path expressions
      let result = expression.replace(/{{([\w.]+)}}/g, (match, path) => {
        const value = ExpressionParser.getNestedValue(data, path)
        return value !== undefined ? value : match
      })

      // Second pass: Find and evaluate full mathematical expressions
      result = result.replace(
        /\d+(?:\.\d+)?(?:\s*[/+\-*]\s*\d+(?:\.\d+)?)+/g,
        (match) => {
          return ExpressionParser.evaluateExpression(match)
        }
      )

      return result
    }

    return expression
  }
}

export default ExpressionParser

// Example usage:
/*
const data = {
    product: {
        amount: 144,
        meta: {
            seats: 4
        }
    }
}

console.log(ExpressionParser.evaluate("144 / 12 / 6", {}))  // "2"
console.log(ExpressionParser.evaluate("{{product.amount}} / 12 / 6", data))  // "2"
console.log(ExpressionParser.evaluate("{{product.amount}} / {{product.meta.seats}}", data))  // "36"
*/
